import { pathBuilder } from 'config/paths/index';
import { root as hubRoot } from 'config/paths/requirementControls';

export const root = `${hubRoot}/evidence`;
export default pathBuilder(root);
